import { createFileRoute } from "@tanstack/react-router";
import Financials from "@/components/Financials";

function RouteComponent() {
  return <Financials />;
}

export const Route = createFileRoute("/_authenticated/financials/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
